/** All buttons and images point at the on-page purchase section. */
export const OFFER_ANCHOR = '#offer'

/** Only the $27 purchase box sends the user to the real checkout. */
export const CHECKOUT_URL = 'https://fono-kids-pro.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ajwD1urv7qq2ZcVa4n8oQz/Diseno-sin-titulo-3-2.webp'

export const previewImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/4U2UWffnkJyJMJ3LZsHSjs/Captura-de-pantalla-2026-09-03-a-la_s_-9.57.02_p._m..png',
    alt: 'FONO KIDS PRO™ activity page — Which One Ends The Same?',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oqRDTa5GNkSKSQhJgEFHmL/Captura-de-pantalla-2026-09-03-a-la_s_-9.56.02_p._m..png',
    alt: 'FONO KIDS PRO™ activity page — Sound Detective',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jRV1rHoZwpw96NsbHdLCqS/Captura-de-pantalla-2026-09-03-a-la_s_-9.57.19_p._m..png',
    alt: 'FONO KIDS PRO™ activity page — Sound Hunt picture scene',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oPYxXTpdYZM7rxkKQgrYoo/Captura-de-pantalla-2026-09-03-a-la_s_-9.56.38_p._m..png',
    alt: 'FONO KIDS PRO™ activity page — Sound Treasure Trail game board',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dGvAdLo7E958cAw6yGjjpF/Captura-de-pantalla-2026-09-03-a-la_s_-9.56.19_p._m..png',
    alt: 'FONO KIDS PRO™ activity page — Build A Sentence cards',
  },
]

export const systemFeatures = [
  'Visual ready-to-use activities',
  'Printable picture cards',
  'Games & activity boards',
  'Sorting & matching resources',
  'Picture scenes & visual prompts',
  'Sequencing & storytelling materials',
  'Professional reusable resources',
]

export const modules = [
  {
    num: 1,
    title: 'SPEECH & ARTICULATION ACTIVITIES™',
    body: 'Access a complete visual collection of ready-to-use speech and articulation resources including picture cards, sound searches, sound-position activities, sorting mats, matching activities, bingo boards, visual game paths, picture challenges and reusable practice materials.',
    note: 'Select and adapt the appropriate resources according to your professional goals and each child’s individual needs.',
    kicker: 'Choose the target. Find the material. Start the activity.',
  },
  {
    num: 2,
    title: 'ORAL LANGUAGE ACTIVITIES™',
    body: 'Work with visual resources designed around oral language, comprehension and expression through illustrated scenes, actions, sentence-building materials, WH-question activities, descriptions, comparisons, visual inference prompts and guided conversation resources.',
    kicker: 'See the scene. Build the language. Expand the response.',
  },
  {
    num: 3,
    title: 'VOCABULARY & CATEGORIES ACTIVITIES™',
    body: 'Access colorful visual materials for vocabulary and semantic organization using animals, food, clothing, home, school, transportation, professions, places, actions, everyday objects, emotions and more.',
    note: 'Use classification boards, matching resources, picture cards, attributes, functions, similarities, differences and visual sorting activities.',
    kicker: 'See it. Name it. Sort it. Connect it.',
  },
  {
    num: 4,
    title: 'PHONOLOGICAL AWARENESS ACTIVITIES™',
    body: 'Use organized visual resources for professionally selected phonological awareness goals, including rhyming, syllable activities, sound identification, initial and final sound tasks, segmentation, blending and visual sound-based challenges.',
    note: 'Activities are structured progressively while remaining adaptable to professional judgment.',
    kicker: 'Listen. Identify. Segment. Connect.',
  },
  {
    num: 5,
    title: 'AUDITORY ATTENTION & MEMORY ACTIVITIES™',
    body: 'Access visual-supported activities for auditory attention, following directions, listening tasks, auditory-visual association, remembering sequences, identifying changes and professionally selected auditory memory activities.',
    note: 'Use clear visual supports alongside verbal stimuli to create practical session material without rebuilding everything yourself.',
    kicker: 'Listen. Remember. Choose. Respond.',
  },
  {
    num: 6,
    title: 'SEQUENCING & NARRATIVE ACTIVITIES™',
    body: 'Use illustrated sequences, storytelling scenes, character cards, event-ordering resources, beginning-middle-end activities, prediction prompts, cause-and-effect materials and guided narrative boards.',
    note: 'Turn visual material into flexible resources for professionally selected sequencing and narrative goals.',
    kicker: 'Order it. Describe it. Connect it. Tell the story.',
  },
]

export const bonuses = [
  {
    num: 1,
    title: 'FONO KIDS SESSION PLANNER™',
    body: 'Organize your professionally defined goals, selected activities, materials and session resources without rebuilding your planning system every week. Use practical planning sheets, resource selectors, preparation checklists, Plan A / Plan B tools and reusable organization templates.',
    kicker: 'Choose. Prepare. Organize.',
  },
  {
    num: 2,
    title: 'ACTIVITY ADAPTATION GUIDE™',
    body: 'Get a practical system for adapting and reusing FONO KIDS PRO™ materials according to your professional judgment. Adjust visual complexity, number of stimuli, response format, supports, instructions and activity presentation without constantly creating new resources.',
    kicker: 'One resource. More ways to use it.',
  },
  {
    num: 3,
    title: 'HOME CONTINUITY KIT™',
    body: 'Turn professionally selected materials into clear, simple continuity resources for families and caregivers when appropriate. Use ready-to-customize instruction sheets, communication templates, observation forms and practical home-continuity formats.',
    kicker: 'Select it. Explain it. Share it clearly.',
  },
  {
    num: 4,
    title: 'SESSION & PROGRESS TRACKER™',
    body: 'Keep your use of activities, observations, adaptations and next steps organized with practical professional tracking templates. Record what you used, how it was presented, what you observed and what you may want to review next.',
    kicker: 'Use. Observe. Record. Review.',
  },
  {
    num: 5,
    title: 'MASTER RESOURCE ORGANIZER™',
    body: 'Keep your FONO KIDS PRO™ library organized and easier to navigate. Catalog materials, track preparation status, organize printable pieces, create favorites, identify missing resources and build a system for quickly locating what you need.',
    kicker: 'Find it. Prepare it. Use it again.',
  },
]

export const differentiators = [
  {
    emoji: '🎴',
    title: 'Ready-to-Use Visual Materials',
    body: 'Open the system and access practical resources instead of starting from scratch.',
  },
  {
    emoji: '✂️',
    title: 'Printable Activities',
    body: 'Cards, boards, sorting materials, games, sequences and visual resources ready to prepare.',
  },
  {
    emoji: '🧩',
    title: '6 Essential Areas',
    body: 'Keep your speech, language, vocabulary, phonological awareness, auditory and narrative resources organized.',
  },
  {
    emoji: '🔄',
    title: 'Reusable Resources',
    body: 'Adapt and reuse materials according to your professional goals and clinical judgment.',
  },
  {
    emoji: '📂',
    title: 'Organized Activity Library',
    body: 'Stop searching through scattered files every time you need something.',
  },
  {
    emoji: '⏱️',
    title: 'Less Material Creation',
    body: 'Spend less time designing resources from scratch and keep more materials ready for your sessions.',
  },
]

export const offerIncludes = [
  '6 Professional Activity Modules',
  '5 Professional Bonuses',
  'Visual Printable Activities',
  'Picture Cards & Games',
  'Sorting & Matching Resources',
  'Picture Scenes & Visual Prompts',
  'Sequencing & Narrative Materials',
  'Planning & Organization Tools',
]

export const testimonials = [
  {
    text: 'I was spending my Sunday evenings cutting, laminating and rebuilding the same articulation cards over and over. Now I open FONO KIDS PRO™, pick the sound position I need and print it in five minutes. My caseload is 42 children and for the first time in three years my prep is finished before Monday.',
    author: 'Charlotte Ainsworth',
    role: 'Speech & Language Therapist, 34',
    location: 'Bristol, United Kingdom',
  },
  {
    text: 'The picture scenes changed how I run oral language sessions. I used to print random photos off the internet; now I have scenes built for WH-questions, descriptions and inferences, with prompts already on the page. Parents notice the difference because the children talk more.',
    author: 'Meghan Doyle',
    role: 'Speech-Language Pathologist, 29',
    location: 'Ottawa, Canada',
  },
  {
    text: 'I work in a school district with six campuses, so everything I use has to be printable and portable. The Master Resource Organizer alone was worth it — I finally know what I have prepared, what is laminated and what is still sitting in a folder. No more duplicate printing.',
    author: 'Danielle Vasquez',
    role: 'School-Based SLP, 41',
    location: 'Austin, United States',
  },
  {
    text: 'Phonological awareness was the area where I always improvised. The rhyming, syllable and segmentation activities are structured progressively, so I can start a child where they are and move up without designing anything myself. My planning time dropped by about two hours a week.',
    author: 'Imogen Barrett',
    role: 'Paediatric Speech Pathologist, 37',
    location: 'Brisbane, Australia',
  },
  {
    text: 'I am in private practice and I see back-to-back sessions all afternoon. Being able to grab a sequencing board or a sound game between children, without opening a design app, is the reason I bought it. The Home Continuity Kit also saved me from writing the same parent notes every week.',
    author: 'Rachel Kirkwood',
    role: 'Private Practice SLT, 45',
    location: 'Manchester, United Kingdom',
  },
]

export const faqs = [
  {
    q: 'Is this a physical product?',
    a: 'No. FONO KIDS PRO™ is a 100% digital professional resource.',
  },
  {
    q: 'Who is this for?',
    a: 'Speech-language professionals looking for organized, visual and ready-to-use pediatric session materials.',
  },
  {
    q: 'Is this a certification or training program?',
    a: 'No. It is a professional activity and resource library, not a certification or substitute for professional education.',
  },
  {
    q: 'Is this another theory-heavy ebook?',
    a: 'No. The core system focuses on practical visual activities, printable resources, cards, games, scenes and ready-to-use materials.',
  },
  {
    q: 'Do I need to create the activities myself?',
    a: 'No. The activities and resources are already created and organized. You select and adapt them according to your professional goals and judgment.',
  },
  {
    q: 'What areas are included?',
    a: 'Speech & Articulation, Oral Language, Vocabulary & Categories, Phonological Awareness, Auditory Attention & Memory, and Sequencing & Narrative.',
  },
  {
    q: 'Can I adapt the activities?',
    a: 'Yes. The resources are designed to be selected and adapted by the professional according to individual needs and goals.',
  },
  {
    q: 'Does it include printable materials?',
    a: 'Yes. The system includes visual resources designed for digital access and printing.',
  },
  {
    q: 'Does it include planning and organization resources?',
    a: 'Yes. The five complementary bonuses include planning, activity adaptation, home continuity, session tracking and resource organization tools.',
  },
  {
    q: "Is it tied to one country's clinical protocol?",
    a: 'No. It is an English-language professional resource designed for an international market and is not intended to replace local clinical standards or professional judgment.',
  },
  {
    q: 'How will I receive it?',
    a: 'You’ll receive immediate digital access after purchase.',
  },
]

export const recentBuyers = [
  { name: 'Charlotte A.', location: 'Bristol, United Kingdom' },
  { name: 'Meghan D.', location: 'Ottawa, Canada' },
  { name: 'Danielle V.', location: 'Austin, United States' },
  { name: 'Imogen B.', location: 'Brisbane, Australia' },
  { name: 'Rachel K.', location: 'Manchester, United Kingdom' },
  { name: 'Sophie L.', location: 'Vancouver, Canada' },
  { name: 'Hannah P.', location: 'Melbourne, Australia' },
  { name: 'Emily R.', location: 'Boston, United States' },
  { name: 'Niamh O.', location: 'Leeds, United Kingdom' },
  { name: 'Claire M.', location: 'Toronto, Canada' },
  { name: 'Jessica T.', location: 'Perth, Australia' },
  { name: 'Amanda S.', location: 'Denver, United States' },
]
